import { notification } from "@mtm/components";
import moment from "moment";
import { sendEmailWandaPlusSubscription } from "../services/EmailNotificationService";
import * as AppSettingsService from "../services/AppSettingsService";
import {
  EmailNotificationValues,
  NotificationWandaPlus,
  TriggerEventId,
} from "../types/EmailNotificationType";
import { getBillingHistory } from "../services/PaymentService/PaymentTransactionService";
import { PaymentTransactionTypeIds } from "../types/PaymentTransactionTypes";
import { formatUTCtoLocalDate } from "./dateFormatters";
const appSettings = AppSettingsService;

const emailWandaPlusSubscription = async (
  careGiverPersonId: number,
  careGiverName: string,
  organizationId: number,
  wandaSubscriptionCost: string,
  subscriptionRenewalDate: string,
) => {
  try {
    let currentDate = moment().format("MM/DD/YYYY");

    const [{ paymentTransactionId }] = await getBillingHistory({
      CustomerPersonId: careGiverPersonId,
      StartDate: moment()
        .utc()
        .subtract(1, "days")
        .format(),
      EndDate: moment()
        .utc()
        .format(),
      PageOffset: 1,
      PageSize: 10,
      PaymentTransactionTypeIds: [PaymentTransactionTypeIds.Subscription],
    });
    
    const wandaplusDetails: NotificationWandaPlus = {
      eventId: TriggerEventId.WandaPlusSubscription,
      personId: careGiverPersonId,
      organizationId: organizationId,
      caregiverName: careGiverName,
      subscriptionType: EmailNotificationValues.PlanName,
      subscriptionDate: currentDate,
      subscriptionPrice: wandaSubscriptionCost,
      transactionId: paymentTransactionId?.toString(),
      subscriptionUpgradeDate: currentDate,
      subscriptionRenewalDate: formatUTCtoLocalDate(
        subscriptionRenewalDate,
        "MM/DD/YYYY"
      ),
      wandaAppBaseUrl: appSettings.getAppMapping().pp,
    };
    await sendEmailWandaPlusSubscription(wandaplusDetails);
  } catch (error) {
    notification.error({
      message: "Error",
      description: "Failed to send email.",
    });
  }
};

export default emailWandaPlusSubscription;
